import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';

import styles from './RestaurantSlider.module.scss';

import headerImg from '@/assets/img/header_image.png';

type Props = {
  infoRef?: React.RefObject<HTMLElement | null>;
};

const slides = [
  { id: 1, img: headerImg, title: 'Слайд 1' },
  { id: 2, img: headerImg, title: 'Слайд 2' },
  { id: 3, img: headerImg, title: 'Слайд 3' },
];

export const RestaurantSlider: React.FC<Props> = ({ infoRef }: Props) => {
  const heroRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const heroEl = heroRef.current;
    if (!heroEl) return;

    const GAP = 10;
    const PADDING = 12;

    const updateDotsBottom = () => {
      const heroHeight = heroEl.clientHeight;
      if (
        window.scrollY > heroHeight * 2 &&
        !heroEl.classList.contains('hidden')
      ) {
        heroEl.classList.add('hidden');
      } else if (
        window.scrollY <= heroHeight * 2 &&
        heroEl.classList.contains('hidden')
      ) {
        heroEl.classList.remove('hidden');
      }
      const infoRect = infoRef?.current?.getBoundingClientRect();
      if (!infoRect) return;

      // расстояние от низа хедера до "желаемой" Y-точки перед инфоблоком
      const desiredY = infoRect.top - GAP; // относ. вьюпорта
      let bottom = heroHeight - desiredY; // сколько "снизу" держать точки

      const min = PADDING;
      const max = Math.max(PADDING, heroHeight - PADDING);
      bottom = Math.round(Math.min(Math.max(bottom, min), max));

      heroEl.style.setProperty('--dots-bottom', `${bottom}px`);
    };

    const rafUpdate = () => requestAnimationFrame(updateDotsBottom);

    updateDotsBottom();
    window.addEventListener('scroll', rafUpdate, { passive: true });
    window.addEventListener('resize', rafUpdate);
    window.addEventListener('load', updateDotsBottom);

    return () => {
      window.removeEventListener('scroll', rafUpdate);
      window.removeEventListener('resize', rafUpdate);
      window.removeEventListener('load', updateDotsBottom);
    };
  }, [infoRef]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  const [extended, setExtended] = useState(false);

  return (
    <>
      <div
        className={classNames(styles.heroSpacer, {
          [styles.extended]: extended,
        })}
      />

      <div
        className={classNames(styles.heroFixed, {
          [styles.extended]: extended,
        })}
        ref={heroRef}
        onClick={() => setExtended(!extended)}
      >
        <div className={styles.sliderOverlay}>
          <Slider {...settings}>
            {slides.map((slide) => (
              <div key={slide.id} className={styles.slide}>
                <img
                  src={slide.img}
                  alt={slide.title}
                  className={styles.image}
                  draggable={false}
                />
              </div>
            ))}
          </Slider>
        </div>

        <div className={styles.overlayText}>Order2Go.ru</div>
      </div>
    </>
  );
};
